
export class MsgLifeServiceTrayRemaining {
    public service_tray_life: number | undefined
    public constructor(init?: Partial<MsgLifeServiceTrayRemaining>) {
        Object.assign(this, init);
    }
}